import VConsole from "vconsole";

export default defineNuxtPlugin((nuxtApp) => {
  // 只在开发环境中启用VConsole
  if (__CUSTOM_ENV__ !== "production" && __CUSTOM_ENV__ !== "development") {
    const vConsole = new VConsole();

    // 提供vConsole给应用
    nuxtApp.provide("vConsole", vConsole);
  }
});
